import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const staffImessageNotificationSentPayloadSchema = z
    .object({
        type: z.literal('staff_imessage_notification_sent').optional(),
        kind: z.string(),
        summary: z.string(),
        resource_type: z.string().nullable().optional(),
        resource_id: z.uuid().nullable().optional(),
        sent_at: z.iso.datetime({ offset: true }),
        sent_at_timezone: z.string().nullable().optional(),
    })
    .strip();

export const staffImessageNotificationSentDefinitions = {
    staff_imessage_notification_sent: defineInvisible(
        'staff_imessage_notification_sent',
        {
            disposition: 'invisible',
            schema: staffImessageNotificationSentPayloadSchema,
            malformed: { kind: 'skip' },
            evidence: null,
        },
    ),
} as const;

export const staffImessageNotificationSentContractFixtures = {
    valid: {
        type: 'staff_imessage_notification_sent',
        kind: 'internal-notification',
        summary: 'Internal notification summary',
        resource_type: 'shift',
        resource_id: '00000000-0000-4000-8000-000000000001',
        sent_at: '2026-08-28T12:00:00Z',
        sent_at_timezone: 'America/New_York',
    },
    malformed: {
        type: 'staff_imessage_notification_sent',
        kind: 'internal-notification',
        summary: 'Internal notification summary',
        sent_at: 'not-a-datetime',
    },
} as const;
